var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'u-text-center': _vm.isCenter }},[_c('VProgressCircular',{attrs:{"size":_vm.circleSize,"color":_vm.color.mainColor,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }